/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::5be9a9ebb9218a8e901e4b7981f2d3aa>>
 * @codegenCommand yarn build:icon-glyphs
 */
import React from 'react';
import { IconTile } from '@atlaskit/icon';
import NewIcon from '@atlaskit/icon/core/page';
import { fg } from '@atlaskit/platform-feature-flags';
import IconObjectOld from '../../glyph-legacy/page/24';

/**
 * __24px `page` icon object__
 *
 * - [Examples](https://atlassian.design/components/icon-object/examples)
 * - [Code](https://atlassian.design/components/icon-object/code)
 * - [Usage](https://atlassian.design/components/icon-object/usage)
 */
var Page24Icon = function Page24Icon(_ref) {
  var label = _ref.label,
    testId = _ref.testId;
  if (fg('icon-object-migration')) {
    return /*#__PURE__*/React.createElement(IconTile, {
      icon: NewIcon,
      appearance: "blueBold",
      size: "24",
      label: label,
      testId: testId,
      LEGACY_fallbackComponent: /*#__PURE__*/React.createElement(IconObjectOld, {
        label: label,
        testId: testId
      })
    });
  } else {
    return /*#__PURE__*/React.createElement(IconObjectOld, {
      label: label,
      testId: testId
    });
  }
};
Page24Icon.displayName = 'Page24Icon';
export default Page24Icon;